module.exports = __webpack_public_path__ + "img/europe-me-transec.aa64c247.png";